class Megamenu {
  constructor(container) {
    this.selectors = {
      announcementBar: ".m-announcement-bar",
      hamburgerButtons: ".m-hamburger-box",
      desktopMenuItems: [".m-menu__item"],
      desktopSubMenus: ".m-mega-menu",
      headerMobile: ".m-header__mobile",
      menuDrawer: "#m-menu-drawer",
      menuDrawerContent: ".m-menu-drawer__content",
      menu: ".m-menu-mobile",
      menuItems: [".m-menu-mobile__item"],
      megaMenuMobile: [".m-megamenu-mobile"],
      backDrop: ".m-menu-drawer__backdrop",
    };
    this.menuSelectors = {
      subMenu: ".m-mega-menu",
    };
    this.activeDesktopMenuItem = null;

    this.sliders = {};
    this.open = false;
    this.drawerFocusTimer = null;
    this.submenuFocusFrame = null;
    this.container = container;
    this.transitionDuration = 0;
    this.domNodes = queryDomNodes(this.selectors);
    this.menuData = [...this.domNodes.desktopMenuItems].map((item) => {
      const header = item.closest("header");
      const menuNodes = queryDomNodes(this.menuSelectors, item);
      return { header, item, ...menuNodes, active: false };
    });
    this.init();

    MinimogTheme = MinimogTheme || {};
    MinimogTheme.headerSliders = this.sliders;
  }

  init() {
    const { hamburgerButtons, backDrop, menuDrawer } = this.domNodes || {};
    if (hamburgerButtons) {
      hamburgerButtons.addEventListener("click", () => {
        this.open ? this.closeMenu() : this.openMenu();
      });
    }
    if (backDrop) {
      backDrop.addEventListener("click", () => {
        this.closeMenu();
      });
    }
    if (menuDrawer) {
      menuDrawer.addEventListener("keydown", (e) => {
        if (e.key === "Tab") {
          this.trapDrawerFocus(e);
          return;
        }
        if (e.key !== "Escape") return;
        e.preventDefault();
        const openSubmenus = [...menuDrawer.querySelectorAll(".m-megamenu-mobile.open")];
        const activeSubmenu = openSubmenus[openSubmenus.length - 1];
        if (activeSubmenu) {
          const level = activeSubmenu.classList.contains("m-megamenu-mobile--level-2") ? "2" : "1";
          this.closeSubMenu(activeSubmenu, level, true);
          return;
        }
        this.closeMenu();
        if (hamburgerButtons) hamburgerButtons.focus();
      });
    }
    this.initMobileMegaMenu();
    this.initDesktopMegaMenu();

    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openCartDrawer, () => {
      this.open && this.closeMenu();
    });
    MinimogEvents.subscribe(MinimogTheme.pubSubEvents.openSearchPopup, () => {
      this.open && this.closeMenu();
    });
  }
  initDesktopMegaMenu() {
    [...this.menuData].forEach((menuItem) => {
      const { item, subMenu } = menuItem;
      if (subMenu) {
        const productsBanner = subMenu.querySelector(".m-mega-product-list");
        if (productsBanner) {
          if (window && window.__sfWindowLoaded) {
            menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
          } else {
            window.addEventListener("load", () => {
              menuItem.productsBannerSlider = this.initProductsBanner(productsBanner);
            });
          }
        }
      }
    });
  }
  closeDesktopSubmenu = (menuItemIndex) => {
    const menuItem = this.menuData[menuItemIndex];
    const { header } = menuItem;
    header && header.classList.remove("show-menu");
  };
  initProductsBanner(banner) {
    const header = banner.closest("header");
    const menuItem = banner.closest(".m-menu__item");
    const screenClass = (header && `.${header.dataset.screen}`) || "";

    const id = banner.dataset.id;
    const sliderContainer = document.querySelector(`.m-product-list-${id}`);
    const columns = sliderContainer.dataset.column;

    let slider;
    slider = new MinimogLibs.Swiper(`${screenClass} .m-product-list-${id}`, {
      slidesPerView: 1,
      loop: false,
      autoplay: false,
      breakpoints: {
        1200: { slidesPerView: columns },
        992: { slidesPerView: columns >= 2 ? 2 : columns },
      },
    });
    this.sliders[menuItem.dataset.index] = slider;

    if (slider) {
      const prevBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-prev`);
      const nextBtn = document.querySelector(`#m-slider-controls-${id} .m-slider-controls__button-next`);
      prevBtn && prevBtn.addEventListener("click", () => slider.slidePrev());
      nextBtn && nextBtn.addEventListener("click", () => slider.slideNext());
    }
  }

  initMobileMegaMenu() {
    [...this.domNodes.menuItems].forEach((item) => {
      const subMenuContainer = item.querySelector(":scope > .m-megamenu-mobile");
      if (!subMenuContainer) return;

      this.setSubMenuState(subMenuContainer, false);
      const triggers = [...item.children].filter((child) => child.matches("button[data-toggle-submenu]"));
      triggers.forEach((trigger) => {
        trigger.addEventListener("click", (e) => {
          e.preventDefault();
          this.openSubMenu(subMenuContainer, trigger.dataset.toggleSubmenu, trigger);
        });
      });

      const backBtn = subMenuContainer.querySelector(":scope > .m-megamenu-mobile__wrapper > .m-menu-mobile__back-button");
      if (backBtn) {
        backBtn.addEventListener("click", () => {
          this.closeSubMenu(subMenuContainer, backBtn.dataset.level, true);
        });
      }
    });

    document.addEventListener("matchMobile", () => this.setMenuHeight());
    document.addEventListener("unmatchMobile", () => this.setMenuHeight());
  }

  //////////////// MOBILE MENU EVENTS
  openMenu() {
    const { menuDrawer, headerMobile, hamburgerButtons } = this.domNodes || {};
    if (!menuDrawer || !headerMobile || !hamburgerButtons) return;
    window.clearTimeout(this.drawerFocusTimer);
    this.setMenuHeight();
    this.resetDrawerHorizontalScroll();
    document.documentElement.classList.add("prevent-scroll");
    menuDrawer.classList.add("open");
    menuDrawer.setAttribute("aria-hidden", "false");
    menuDrawer.removeAttribute("inert");
    headerMobile.classList.add("header-drawer-open");
    hamburgerButtons.classList.add("active");
    hamburgerButtons.setAttribute("aria-expanded", "true");
    hamburgerButtons.setAttribute("aria-label", hamburgerButtons.getAttribute("data-close-label") || "Close navigation menu");
    this.open = true;
    this.drawerFocusTimer = window.setTimeout(() => {
      if (!this.open) return;
      const firstControl = this.getFocusableElements(menuDrawer)[0];
      firstControl && firstControl.focus({ preventScroll: true });
      this.resetDrawerHorizontalScroll();
    }, 50);
  }

  closeMenu() {
    const { menuDrawer, menu, megaMenuMobile, hamburgerButtons, headerMobile } = this.domNodes || {};
    if (!menuDrawer || !hamburgerButtons) return;
    window.clearTimeout(this.drawerFocusTimer);
    window.cancelAnimationFrame(this.submenuFocusFrame);

    if (menuDrawer.contains(document.activeElement)) {
      hamburgerButtons.focus({ preventScroll: true });
    }

    (megaMenuMobile || []).forEach((container) => {
      this.setSubMenuState(container, false);
    });
    menu && menu.classList.remove("m-submenu-open", "m-submenu-open--level-1", "m-submenu-open--level-2");
    this.domNodes.menuDrawerContent && this.domNodes.menuDrawerContent.classList.remove("open-submenu");
    menuDrawer.classList.remove("open");
    menuDrawer.setAttribute("aria-hidden", "true");
    menuDrawer.setAttribute("inert", "");
    document.documentElement.classList.remove("prevent-scroll");
    headerMobile && headerMobile.classList.remove("header-drawer-open");
    hamburgerButtons.classList.remove("active");
    hamburgerButtons.setAttribute("aria-expanded", "false");
    hamburgerButtons.setAttribute("aria-label", hamburgerButtons.getAttribute("data-open-label") || "Open navigation menu");
    this.resetDrawerHorizontalScroll();
    this.open = false;
  }

  setSubMenuState(subMenuContainer, expanded) {
    if (!subMenuContainer) return;
    subMenuContainer.classList.toggle("open", expanded);
    subMenuContainer.setAttribute("aria-hidden", expanded ? "false" : "true");
    if (expanded) {
      subMenuContainer.removeAttribute("inert");
    } else {
      subMenuContainer.setAttribute("inert", "");
    }

    const submenuId = subMenuContainer.id;
    const parent = subMenuContainer.parentElement;
    if (!submenuId || !parent) return;
    [...parent.children]
      .filter((child) => child.getAttribute && child.getAttribute("aria-controls") === submenuId)
      .forEach((control) => control.setAttribute("aria-expanded", expanded ? "true" : "false"));
  }

  openSubMenu(subMenuContainer, level, trigger) {
    const { menuDrawer } = this.domNodes || {};
    if (!menuDrawer || !subMenuContainer) return;

    [...menuDrawer.querySelectorAll(".m-megamenu-mobile.open")].forEach((openPanel) => {
      const isAncestor = openPanel !== subMenuContainer && openPanel.contains(subMenuContainer);
      if (!isAncestor) this.setSubMenuState(openPanel, false);
    });

    subMenuContainer.__deckauraTrigger = trigger;
    this.setSubMenuState(subMenuContainer, true);
    this.syncMobileMenuState();
    this.resetDrawerHorizontalScroll();
    window.cancelAnimationFrame(this.submenuFocusFrame);
    this.submenuFocusFrame = requestAnimationFrame(() => {
      const destination = subMenuContainer.querySelector(".m-menu-mobile__back-button, a[href], button:not([disabled])");
      destination && destination.focus({ preventScroll: true });
      this.resetDrawerHorizontalScroll();
    });
  }

  closeSubMenu(subMenuContainer, level, restoreFocus = false) {
    if (!subMenuContainer) return;
    const trigger = subMenuContainer.__deckauraTrigger;

    if (restoreFocus && trigger) {
      trigger.focus({ preventScroll: true });
    }
    subMenuContainer.querySelectorAll(".m-megamenu-mobile.open").forEach((panel) => this.setSubMenuState(panel, false));
    this.setSubMenuState(subMenuContainer, false);
    this.syncMobileMenuState();
    this.resetDrawerHorizontalScroll();
  }

  syncMobileMenuState() {
    const { menuDrawer, menu, menuDrawerContent } = this.domNodes || {};
    if (!menuDrawer || !menu) return;
    const openPanels = [...menuDrawer.querySelectorAll(".m-megamenu-mobile.open")];
    const hasOpenPanel = openPanels.length > 0;

    menu.classList.toggle("m-submenu-open", hasOpenPanel);
    ["1", "2"].forEach((level) => {
      const hasLevel = openPanels.some((panel) => panel.classList.contains(`m-megamenu-mobile--level-${level}`));
      menu.classList.toggle(`m-submenu-open--level-${level}`, hasLevel);
    });
    menuDrawerContent && menuDrawerContent.classList.toggle("open-submenu", hasOpenPanel);
  }

  resetDrawerHorizontalScroll() {
    const { menuDrawer } = this.domNodes || {};
    if (!menuDrawer) return;
    menuDrawer
      .querySelectorAll(".m-menu-drawer__wrapper, .m-menu-drawer__content, .m-megamenu-mobile__wrapper")
      .forEach((element) => {
        element.scrollLeft = 0;
      });
  }

  getFocusableElements(container) {
    if (!container) return [];
    const selector = [
      "a[href]",
      "button:not([disabled])",
      "input:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      "[tabindex]:not([tabindex='-1'])",
    ].join(",");
    return [...container.querySelectorAll(selector)].filter((element) => {
      if (element.closest("[inert]") || element.getAttribute("aria-hidden") === "true") return false;
      return element.getClientRects().length > 0;
    });
  }

  trapDrawerFocus(event) {
    const { menuDrawer } = this.domNodes || {};
    if (!this.open || !menuDrawer) return;
    const openSubmenus = [...menuDrawer.querySelectorAll(".m-megamenu-mobile.open")];
    const activePanel = openSubmenus[openSubmenus.length - 1] || menuDrawer;
    const focusable = this.getFocusableElements(activePanel);
    if (!focusable.length) return;

    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;
    if (!activePanel.contains(active)) {
      event.preventDefault();
      (event.shiftKey ? last : first).focus();
    } else if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  setMenuHeight() {
    const { menuDrawer, headerMobile } = this.domNodes || {};
    if (!menuDrawer || !headerMobile) return;
    const offsetBottom = headerMobile.getBoundingClientRect().bottom;
    const panelHeight = window.innerHeight - offsetBottom;

    menuDrawer.style.setProperty("--menu-drawer-height", `${panelHeight}px`);
  }
}
class SiteNav {
  constructor(container) {
    this.selectors = {
      menuItems: [".m-menu .m-menu__item"],
      dropdowns: [".m-mega-menu"],
      subMenu: ".m-mega-menu",
      overlay: ".m-header__overlay",
      swiper: ".swiper-container",
    };

    this.classes = {
      slideFromRight: "slide-from-right",
      slideReveal: "slide-reveal",
      active: "m-mega-active",
    };

    this.headerSticky = false;

    if (!container) return;
    this.container = container;
    this.domNodes = queryDomNodes(this.selectors, this.container);
    this.activeIndex = -1;
    this.lastActiveIndex = -1;
    this.visited = false;
    this.timeoutEnter = null;
    this.timeoutLeave = null;
    this.attachEvents();
  }

  attachEvents = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.addEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.addEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));

      const submenu = menuItem.querySelector(":scope > .m-mega-menu");
      const control = menuItem.querySelector(":scope > .m-menu__link--main");
      if (!submenu || !control) return;

      control.setAttribute("aria-haspopup", "true");
      control.setAttribute("aria-expanded", "false");

      menuItem.addEventListener("focusin", () => {
        this.onMenuItemEnter({ target: menuItem }, index);
      });

      menuItem.addEventListener("focusout", (evt) => {
        if (evt.relatedTarget && menuItem.contains(evt.relatedTarget)) return;
        this.onMenuItemLeave({ target: menuItem }, index);
      });

      menuItem.addEventListener("keydown", (evt) => {
        if (evt.key === "ArrowDown" && evt.target === control) {
          evt.preventDefault();
          this.onMenuItemEnter({ target: menuItem }, index);
          window.setTimeout(() => {
            const firstLink = submenu.querySelector("a");
            firstLink && firstLink.focus();
          }, 140);
        }

        if (evt.key === "Escape") {
          evt.preventDefault();
          control.focus();
          this.onMenuItemLeave({ target: menuItem }, index);
        }
      });
    });
  };

  initDropdownSize = () => {
    this.container && this.container.style.setProperty("--sf-dropdown-width", this.windowWidth());
    this.container && this.container.style.setProperty("--sf-dropdown-height", this.windowHeight());
  };

  onMenuItemEnter = (evt, index) => {
    const { target } = evt;

    if (!target.classList.contains("m-menu__item--mega")) return;

    const control = target.querySelector(":scope > .m-menu__link--main");
    control && control.setAttribute("aria-expanded", "true");

    clearTimeout(this.timeoutLeave);
    this.activeIndex = target.dataset && Number(target.dataset.index);
    this.headerSticky = this.container && this.container.dataset.sticky === "true";
    this.reInitSlider(target);

    this.container && this.visited
      ? this.container.classList.remove(this.classes.slideReveal)
      : this.container.classList.add(this.classes.slideReveal);

    this.visited = true;
    this.lastActiveIndex >= 0 &&
      this.activeIndex >= 0 &&
      (this.container && this.lastActiveIndex < this.activeIndex
        ? this.container.classList.add(this.classes.slideFromRight)
        : this.lastActiveIndex > this.activeIndex && this.container.classList.remove(this.classes.slideFromRight));

    this.getElementBoundingRect(target).then((rect) => {
      if (rect) {
        this.container && this.container.style.setProperty("--sf-dropdown-width", rect.width);
        this.container && this.container.style.setProperty("--sf-dropdown-height", rect.height);
      }

      this.timeoutEnter = setTimeout(() => {
        if (this.activeIndex !== Number(target.dataset.index)) return;
        this.container && this.container.classList.add(this.classes.active);
        target.closest(".m-menu__item").classList.add("m-menu__item--active");
        // document.documentElement.classList.add("prevent-scroll");
      }, 120);
    });
  };

  onMenuItemLeave = (evt, index) => {
    this.activeIndex = -1;
    this.lastActiveIndex = index;
    evt.target.closest(".m-menu__item").classList.remove("m-menu__item--active");
    const control = evt.target.closest(".m-menu__item").querySelector(":scope > .m-menu__link--main");
    control && control.setAttribute("aria-expanded", "false");
    // document.documentElement.classList.remove("prevent-scroll");

    this.timeoutLeave = setTimeout(() => {
      if (this.activeIndex === -1 || this.activeIndex < 0) {
        this.visited = false;
      }
      this.resetMegaMenu(evt.target);
    }, 80);
  };

  reInitSlider = (menuItem) => {
    const swiper = menuItem.querySelector(this.selectors.swiper);
    if (!swiper) return;
    const itemIndex = menuItem.dataset.index;
    const slider = MinimogTheme && MinimogTheme.headerSliders[itemIndex];
    slider && slider.update();
  };

  getElementBoundingRect = async (element) => {
    const subMenu = element.querySelector(this.selectors.subMenu);
    if (subMenu) {
      const rect = subMenu.getBoundingClientRect();
      return {
        width: rect.width,
        height: rect.height,
        left: rect.left,
        top: rect.top,
      };
    }
  };

  resetMegaMenu = () => {
    this.activeIndex = -1;

    clearTimeout(this.timeoutEnter);
    this.container &&
      this.container.classList.remove(
        this.classes.active,
        this.classes.slideFromRight,
        this.classes.slideReveal,
        "sf-header--bg-black",
        "sf-header--bg-white"
      );
  };

  windowWidth = () => {
    return window.innerWidth;
  };
  windowHeight = () => {
    return window.innerHeight;
  };

  destroy = () => {
    this.domNodes.menuItems.forEach((menuItem, index) => {
      menuItem.removeEventListener("mouseenter", (evt) => this.onMenuItemEnter(evt, index));
      menuItem.removeEventListener("mouseleave", (evt) => this.onMenuItemLeave(evt, index));
    });
  };
}
